import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom'
import {store} from "./redux/state";
import registerServiceWorker from './registerServiceWorker';
import './index-1.css';
import './dropdowns.css';

ReactDOM.render(<Provider store={store}>
  <Router>
    <App/>
  </Router>
</Provider>, document.getElementById("root"),);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js